import React, { useState, useEffect } from "react"
import * as styles from "./filter.module.scss"
import Button from "../../../../components/common/jsx/button/button"
import { DatoCmsThematicFolder } from "../../../../../graphql-types"
import { $mobileBreakpoint } from "../../../../../variables.scss"
type FilterProps = {
  filterThematicFolders: any
  thematicFolders: Array<DatoCmsThematicFolder>
  filters: Array<string>
  allFilterLabel: string
}

const Filter: React.FC<FilterProps> = ({
  filterThematicFolders,
  thematicFolders,
  filters,
  allFilterLabel,
}) => {
  const [isFilterSelected, setIsFilterSelected] = useState(false)
  const [selectedFilterName, setSelectedFilterName] = useState(undefined)

  // "All" filter is selected by default
  useEffect(() => {
    setSelectedFilterName(allFilterLabel)
    setIsFilterSelected(true)
  }, [])

  const displayFilters = (): JSX.Element => {
    
    return (
      <section className={styles.container}>
        <div className={styles.buttonContainer}>
          <Button
            data={{ title: `${allFilterLabel}` }}
              isFilterButton={true}
              isFilterSelected={isFilterSelected && allFilterLabel === selectedFilterName}
              disabled={isFilterSelected && allFilterLabel === selectedFilterName}
              onClick={() => handleAllFilterSelection(allFilterLabel)}
            />
        </div>
        {filters.map((filter, index) => (
          <div key={index} className={styles.buttonContainer}>
            <Button
              data={{ title: `${filter}` }}
              isFilterButton={true}
              isFilterSelected={isFilterSelected && filter === selectedFilterName}
              disabled={isFilterSelected && filter === selectedFilterName}
              onClick={() => handleFilterSelection(filter)}
            />
          </div>
        ))}
      </section>
    )
  }

  /**
   * Handle filter selection when it's not ALL articles filter.
   * @param filterName
   */
  const handleFilterSelection = (filterName): void => {
    setSelectedFilterName(filterName)
    setIsFilterSelected(true)

    const filteredThematicFolders: Array<DatoCmsThematicFolder> = []
    thematicFolders.forEach(thematicFolder => {
      if (thematicFolder.thematicTitle === filterName || thematicFolder.tfThumbnailTitle === filterName) {
        filteredThematicFolders.push(thematicFolder)
      }
    })
    filterThematicFolders(filteredThematicFolders)
  }

  /**
   * Handle ALL filter selection
   * @param filterName
   */
  const handleAllFilterSelection = (filterName): void => {
    setSelectedFilterName(filterName)
    setIsFilterSelected(true)

    filterThematicFolders(thematicFolders)
  }

  return <div>{displayFilters()}</div>
}

export default Filter
